module.exports = vendors_tr_bde49fc63a3ba928f00b;